export const getLoyaltyGroups = (upId: number | null) => {
	return {
		url: upId ? `loyalty-management/loyalty/groups?upId=${upId}` : 'loyalty-management/loyalty/groups',
	};
};
